<div class="container-fluid py-3">

  <!-- Header -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h4 class="mb-0 fw-semibold">Item Master <small class="text-muted fs-6 fw-normal">(Books)</small></h4>
    <button class="btn btn-primary btn-sm" (click)="openAdd()">+ Add Item</button>
  </div>

  <!-- Alerts -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible py-2" role="alert">
    {{ successMessage }}
    <button type="button" class="btn-close btn-sm" (click)="successMessage = ''"></button>
  </div>
  <div *ngIf="errorMessage && !isSaving" class="alert alert-danger py-2">
    {{ errorMessage }}
  </div>

  <!-- Items Table -->
  <div class="card border-0 shadow-sm">
    <div class="card-body p-0">
      <div *ngIf="isLoading" class="text-center py-4 text-muted">Loading items…</div>
      <vio-table-v2
        *ngIf="!isLoading"
        [tableData]="itemsForTable"
        [tableConfig]="tableConfig">
      </vio-table-v2>
    </div>
  </div>

</div>

<!-- ===== Add Item Modal ===== -->
<div class="modal fade" tabindex="-1" #addItemModal>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Item</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger py-2 mb-3">{{ errorMessage }}</div>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Item Code <span class="text-danger">*</span></label>
            <input class="form-control" [(ngModel)]="newItem.itemCode" placeholder="e.g. BK001" />
          </div>
          <div class="col-md-8">
            <label class="form-label">Title <span class="text-danger">*</span></label>
            <input class="form-control" [(ngModel)]="newItem.title" placeholder="Book title" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Author</label>
            <input class="form-control" [(ngModel)]="newItem.author" placeholder="Author name" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Price (₹)</label>
            <input type="number" class="form-control" [(ngModel)]="newItem.price" placeholder="0.00" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Genre</label>
            <input class="form-control" [(ngModel)]="newItem.genre" placeholder="Fiction, etc." />
          </div>
          <div class="col-12">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" [(ngModel)]="newItem.description" placeholder="Short description shown on WhatsApp card"></textarea>
          </div>
          <div class="col-12">
            <label class="form-label">Cover Image <span class="text-danger">*</span></label>
            <input type="file" class="form-control" accept="image/*" (change)="onNewImageChange($event)" />
            <div *ngIf="newImagePreview" class="mt-2">
              <img [src]="newImagePreview" alt="preview" class="img-preview" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button class="btn btn-primary" (click)="saveNewItem()" [disabled]="isSaving">
          {{ isSaving ? 'Saving…' : 'Save Item' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ===== Edit Item Modal ===== -->
<div class="modal fade" tabindex="-1" #editItemModal>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Item — {{ editItem.itemCode }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger py-2 mb-3">{{ errorMessage }}</div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Title <span class="text-danger">*</span></label>
            <input class="form-control" [(ngModel)]="editItem.title" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Author</label>
            <input class="form-control" [(ngModel)]="editItem.author" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Price (₹)</label>
            <input type="number" class="form-control" [(ngModel)]="editItem.price" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Genre</label>
            <input class="form-control" [(ngModel)]="editItem.genre" />
          </div>
          <div class="col-12">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" [(ngModel)]="editItem.description"></textarea>
          </div>
          <div class="col-12">
            <label class="form-label">Cover Image <small class="text-muted">(leave blank to keep current)</small></label>
            <input type="file" class="form-control" accept="image/*" (change)="onEditImageChange($event)" />
            <div *ngIf="editImagePreview" class="mt-2">
              <img [src]="editImagePreview" alt="preview" class="img-preview" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button class="btn btn-primary" (click)="saveEdit()" [disabled]="isSaving">
          {{ isSaving ? 'Saving…' : 'Update Item' }}
        </button>
      </div>
    </div>
  </div>
</div>
